import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import mainSlice from './main/slice';

const rootReducer = combineReducers({
  main: mainSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ immutableCheck: true, serializableCheck: false, thunk: false }),
});

export type AppState = ReturnType<typeof store.getState>;
export default store;
